import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogClickTypeFilter = () => {
  return useCallback((marketTypeName: string) => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_TYPE_FILTER',
      analytics: {
        SCREEN: 'MARKET_RANKING',
        MARKET_TYPE: marketTypeName,
      },
    });
  }, []);
};
